import React from "react";
import Collapse from "@material-ui/core/Collapse";
import { useDispatch, useSelector } from "react-redux";

import { api } from "../../Services/Api";
import { renameCategory } from "../../Store/Modules/Menu/Actions";
import Product from "../Product";
import Header from "./Header";
import DragAndDrop from "../DragAndDrop";
import CategoryReducer from "./CategoryReducer";

import { Container, ListProducts } from "./style";

export default function Category({
  forceClosed = false,
  onOpen = () => {},
  id,
}) {
  const reduxDispatch = useDispatch();
  const { data } = useSelector((state) => {
    const category = state.menu.menu.find((category) => category._id === id);
    return {
      data: category,
    };
  });

  const [open, setOpen] = React.useState(false);
  const [state, dispatch] = React.useReducer(CategoryReducer, {
    ...data,
    opened: forceClosed ? false : true,
  });

  const handleOpenChange = () => {
    onOpen();
    if (forceClosed) return;
    dispatch({ type: "TOGGLE" });
  };

  React.useEffect(() => {
    dispatch({ type: "INIT", category: data });
  }, [data]);

  

  const handleReorderChange = async (products) => {
    dispatch({ type: "INIT", category: { itens: products } });
    try {
      await api.put(`menu/categories/${state._id}/reorder-products`, {
        orderedListId: products.map((product) => product._id),
      });
    } catch (err) {
      alert("Não foi possível reordenar os produtos");
    }
    //reduxDispatch(renameCategory({ ...state, itens: productListNames }));
  };

  return (
    <Container>
      <Header data={data} onToggle={handleOpenChange} />
      <Collapse in={state.opened}>
        <DragAndDrop
          onMyDragStart={() => setOpen(true)}
          onMyDragEnd={() => setOpen(false)}
          list={state.itens}
          onUpdateList={handleReorderChange}
          ContainerToRender={ListProducts}
          ItemToRender={({ data: prod }) => (
            <Product key={prod._id} data={prod} />
          )}
        />
      </Collapse>
      {/* {state.itens.map((prod) => (
        <Product key={prod._id} data={prod} />
      ))} */}
    </Container>
  );
}
